"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("../utils/styled"));
const Card_1 = __importDefault(require("../Card/Card"));
const utils_1 = require("../utils");
const CardHeader_1 = require("../Internals/CardHeader");
const Modal_util_1 = require("./Modal.util");
exports.Overlay = styled_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  z-index: ${({ theme }) => theme.zIndex.modal - 1};
`;
// We use styled("div") here to filter out `height` and `width` props.
exports.Container = styled_1.default("div", {
    shouldForwardProp: prop => !["width", "height", "top", "left", "modalHeight", "anchorHeight"].includes(prop),
}) `
  position: fixed;
  margin: 0 auto;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.32);
  top: ${({ top, theme, anchorHeight }) => `calc(${Modal_util_1.getTop({ top, theme, height: anchorHeight || 0 })}px + ${theme.space.content}px)`};
  left: ${({ left }) => `${left}px`};
  right: ${({ left }) => (left ? "auto" : 0)};
  width: ${({ width, theme }) => width === "max-content" ? "max-content" : `calc(${width}px - ${theme.space.content * 2}px)`};
  max-width: calc(100vw - ${({ left, theme }) => theme.space.content * 2 /* <- two sides */ + left}px);
  height: ${Modal_util_1.getContainerHeight};
  max-height: calc(100vh - ${({ theme }) => theme.space.content * 2}px);
  z-index: ${({ theme }) => theme.zIndex.modal};

  min-width: 480px;
  border-radius: 4px;

  :focus {
    outline: none;
  }
`;
exports.ModalCard = styled_1.default(Card_1.default) `
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
`;
exports.ModalContent = styled_1.default("div", {
    shouldForwardProp: prop => !["top", "action", "anchor"].includes(prop),
}) `
  display: grid;
  grid-template-rows: ${({ actions }) => (actions ? "minmax(auto, 100%) max-content" : "auto")};
  height: 100%;
  max-height: calc(
    /* card title + bottom padding + bottom margin + border */ 100vh -
      ${({ theme, top }) => CardHeader_1.cardHeaderHeight + theme.space.element + theme.space.element + theme.space.element + 1 + top * 2}px
  );
  overflow: auto;
  row-gap: ${({ theme }) => theme.space.element}px;

  ${({ theme }) => utils_1.customScrollbar({ theme })};
`;
exports.Actions = styled_1.default.div `
  display: grid;
  grid-template-columns: ${({ childCount }) => `repeat(${childCount}, max-content)`};
  margin-top: auto;
`;
exports.ContentWrapper = styled_1.default.div `
  overflow: auto;
  height: 100%;
  ${({ theme }) => utils_1.customScrollbar({ theme })}
`;
//# sourceMappingURL=Modal.styled.js.map